<template>
  <d2-container>
   <div class="supports">
      <div class="supportcontent">
        <div class="supportcontcard">
          <h4 class="supportcontcardTitle">联系我们</h4>
          <div class="supportcontcardMsg">
            <p>根据您点击的产品详情在您表单提交后，</p>
            <p>会有工作人员第一时间与您电话联系</p>
            <p>如果您现在就需要帮助，可立即拨打 <span>17858952922</span> 与我们联系!</p>
          </div>
          <el-form :model="form" status-icon :rules="rules" ref="form" label-width="17%" class="demo-ruleForm">
            <el-form-item label="算力资源id" prop="power_id" v-show="false">
              <el-input v-model="form.power_id" placeholder="请输入您的称呼" v-show="false"></el-input>
            </el-form-item>
            <el-form-item label="称呼" prop="name" >
              <el-input v-model="form.name" placeholder="请输入您的称呼" clearable></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入您的电话" clearable></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email" >
              <el-input v-model="form.email" placeholder="请输入您的邮箱地址" clearable></el-input>
            </el-form-item>
            <el-form-item label="单位" prop="corp">
              <el-input v-model="form.corp" placeholder="请输入您的单位名称"></el-input>
            </el-form-item>
            <el-form-item label="行业" prop="industry">
              <el-input v-model="form.industry" placeholder="请输入您的行业"></el-input>
            </el-form-item>
            <el-form-item label="需求" prop="demand">
              <el-input type="textarea" :rows="5" v-model="form.demand"></el-input>
            </el-form-item>
            <el-form-item >
              <el-button type="primary" class="login-btn" @click="doSubmit" style="width:55%; color:#fff !important;" >               <span style="color:#fff !important;"> 提交</span>
              </el-button>
            </el-form-item>
          </el-form>
          </div>
      </div>

      <!-- <base-bottom></base-bottom> -->
   </div>
  </d2-container>
</template>
<script>
import baseBottom from '../components/base-bottom';
import { addNewList } from "@/api/data.js";

export default {
  name: 'hosting',
  components: {
    baseBottom
  },
  data() {
    return {
      captchaInstance: null,
      form: {
        power_id: '',
        name: '',
        phone: '',
        email: '',
        corp: '',
        industry: '',
        authcode: '',
        demand: '',
        captchaToken: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入您的称呼', trigger: 'blur' },
          { min: 2, max: 20, message: '称呼长度应在2到20个字符之间', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入您的电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的电话号码', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入您的邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入有效的邮箱地址', trigger: 'blur' }
        ],
      }
    };
  },
  created() {
    this.form.power_id = this.$route.query.power_id || 0;
    this.initCaptcha();
  },
  methods: {
    doSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitForm();
        } else {
          this.$message.error('请检查表单内容');
          return false;
        }
      });
    },
    submitForm() {
      this.$axios.post('/api/power_contact_us', this.form)
        .then(resp => {
          if (resp.code === 200) {
            this.$message.success(resp.msg || '提交成功');
            this.$router.push('/m/successMsg');
          } else {
            this.$message.error(resp.msg || '提交失败，请稍后重试');
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试');
          console.error('提交失败:', error);
        });
    }
  }
};
</script>


<style scoped>
@media (min-width: 769px) {
    /* PC端样式 */
.supports{
  width: 100%;
  min-height: 100vh;
}
.supportcontent{
  /* background: url(/image/portalimg/support/card.png) no-repeat center center; */
  width: 100%;
  margin: 50px auto 100px;
}
.supportcontcard{
    width: 100%;
}
.supportcontcardMsg {
  font-size: 12px;
  color: #333;
  letter-spacing: 0px;
  text-align: left;
  font-weight: 400;
  padding: 0 0 20px 7%;
  margin: 0;
}
.supportcontcardMsg p{
  margin: 8px 0;
}
.supportcontcardMsg p span{
  color: #409EFF;
}
.supportcontcardTitle{
  text-align: left;
  font-size: 20px;
  color: #000;
  letter-spacing: 2px;
  font-weight: 400;
  margin: 0;
  padding: 20px 7% 12px;
  font-weight: bold;
}

.demo-ruleForm{
  margin:0 5%;
}

.el-form-item{
  margin-bottom: 15px !important;
}

::v-deep .el-form-item__label {
    font-size: 12px !important; /* 根据需要调整 */
    line-height: 40px;
}

::v-deep .el-input__inner {
    height: 35px; /* 调整高度 */
    line-height: 35px; /* 保证文本垂直居中 */
    font-size: 12px; /* 调整字体大小 */
}
::v-deep .item__error{
  top:58px;
}
.login-btn span{
  color:#fff !important;
}
.el-textarea{
  margin-top: 0px !important;
}

#c aptcha-element {
  width: 360px;
  height: 40px;
  margin-top: 10px;
}
#aliyunCaptcha-window-embed{
  z-index: 1 !important;
  padding: 8px 5px;
}
#supportcontcardMsg{
  margin-right: 5%;
}
 .login-btn{
    color: #fff !important;
  }
  .login-btn span{
    color: #fff !important;
  }
  #submit-btn{
    color: #fff !important;
  }
  #submit-btn span{
    color: #fff !important;
  }
}
@media (max-width: 768px) {
    /* 移动端样式 */
  .login-btn{
    color: #fff !important;
  }
  .login-btn span{
    color: #fff !important;
  }
  #submit-btn{
    color: #fff !important;
  }
  #submit-btn span{
    color: #fff !important;
  }
}
</style>
